<po-button p-label="Filtros" p-icon="{{seeFilter ? funnelIconFill : funnelIcon }}"
    (p-click)="onClick.emit()"></po-button>